import { BarChart, Bar, XAxis, ResponsiveContainer, Tooltip } from "recharts";
import { DashboardCard } from "@/shared/ui/DashboardCard";
import { ChartTooltip } from "@/shared/ui/ChartTooltip";
import { useChartTheme } from "@/shared/hooks/useChartTheme";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import { trafficData } from "../data";

export function TrafficChart() {
  const { tick, inactive } = useChartTheme();
  const { t } = useTranslation();

  return (
    <DashboardCard title={t.analytics.trafficOverview} className="col-span-full md:col-span-2">
      <ResponsiveContainer width="100%" height={240}>
        <BarChart data={trafficData} barCategoryGap="20%">
          <XAxis
            dataKey="day"
            axisLine={false}
            tickLine={false}
            tick={{ fill: tick, fontSize: 12 }}
            dy={8}
            tickFormatter={(v) => t.common.months[v] ?? v}
          />
          <Tooltip content={<ChartTooltip />} />
          <Bar dataKey="visitors" fill="#4680ff" radius={[6, 6, 0, 0]} maxBarSize={40} />
          <Bar dataKey="pageViews" fill={inactive} radius={[6, 6, 0, 0]} maxBarSize={40} />
        </BarChart>
      </ResponsiveContainer>
    </DashboardCard>
  );
}
